import { EntityContract } from "./contracts/EntityContract.js";

export class EntityService extends EntityContract {

    constructor(options = {}) {
        super();

        const {
            dataApi,
            codelistApi = null,
        } = options;

        if (!dataApi) throw new Error('EntityService: "dataApi" is required.');

        this.dataApi = dataApi;
        this.codelistApi = codelistApi;

    }

    async queryData(query = null) { return this.dataApi.queryData(query); }

    async readData(publicId) { return this.dataApi.readData(publicId); }

    async createData(data) { return this.dataApi.createData(data); }

    async updateData(publicId, data) { return this.dataApi.updateData(publicId, data); }

    async deleteData(publicId) { return this.dataApi.deleteData(publicId); }

    async queryCodelistData(query = null, options = {}) {

        if (!this.codelistApi) {
            throw new Error('EntityService: "codelistApi" is not configured.');
        }

        return this.codelistApi.queryCodelistData(query, options);

    }
}
